/* eslint-disable no-lonely-if */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
import superagent from "superagent";
import Cookies from "universal-cookie";
import { IS_LOADING, THROW_ERROR, THROW_SUCCESS } from "../../store/constants";
import { base_url } from "../../utils/constants";
import { SET_INTENDED_URL } from "../reduxinsurance/constants";
import { GET_IS_PRO_MEMBER, REMOVE_ACCOUNT_DATA } from "../account/constants";
import { getAccountInformation } from "../account/actions";
import { HeaderSlugs, UserRole } from "../../enum/user";

const cookie = new Cookies();

export const loginAction = (data, stopLoader, actions, history, intendedUrl, pathName) => (dispatch) => {
  dispatch({ type: IS_LOADING, payload: true });
  const rememberData = data.remember_me;
  const expireTime = rememberData ? new Date(Date.now() + 3600 * 1000 * 24 * 30) : new Date(Date.now() + 3600 * 1000 * 24);
  const redirectUrl = data?.redirect_url;

  return superagent
    .post(`${base_url}login`)
    .send(data)
    .set("accept", "application/json")
    .end((err, res) => {
      if (res) {
        stopLoader?.();
        if (res.body.status) {
          dispatch({ type: THROW_SUCCESS, payload: res.body.message });
          actions.resetForm({});
          const token = `Bearer ${res.body.token}`;
          cookie.set("user_token", token, {
            path: "/",
            expires: expireTime,
          });
          dispatch(getAccountInformation());
          cookie.set("user_info", res.body.user_info, {
            path: "/",
            expires: expireTime,
          });
          if (res?.body?.role === UserRole?.Admin) {
            window.location.replace(HeaderSlugs?.Admin);
          } else {
            if (intendedUrl) {
              history.push(intendedUrl);
              dispatch({ type: SET_INTENDED_URL, payload: "" });
            } else if (pathName) {
              sessionStorage.removeItem("redirect_to");
              history.push(pathName);
            } else if (res.body.url) {
              if (res.body.url.includes("?")) {
                window.location = res.body.url;
              }
              if (redirectUrl !== "null" && redirectUrl) {
                window.location = decodeURIComponent(redirectUrl);
              } else {
                history.push("/dashboard");
              }
            } else {
              history.push("/dashboard");
            }
          }
        } else {
          dispatch({ type: THROW_ERROR, payload: res.body.message });
        }
      } else {
        dispatch({ type: THROW_ERROR, payload: err?.data?.message });
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
};

export const loginModalAction = (data, actions, history, modal) => (dispatch) => {
  dispatch({ type: IS_LOADING, payload: true });

  return superagent
    .post(`${base_url}login`)
    .send(data)
    .set("accept", "application/json")
    .end((err, res) => {
      if (res) {
        if (res.body.status) {
          dispatch({ type: THROW_SUCCESS, payload: res.body.message });
          actions.resetForm({});
          const token = `Bearer ${res.body.token}`;
          cookie.set("user_token", token, {
            path: "/",
            expires: new Date(Date.now() + 3600 * 1000 * 24),
          });
          cookie.set("user_info", res.body.user_info, {
            path: "/",
            expires: new Date(Date.now() + 3600 * 1000 * 24),
          });
          const userInfo = JSON.parse(res.body.user_info);
          if (res?.body?.role === UserRole?.Admin) {
            window.location.replace(HeaderSlugs?.Admin);
          } else {
            if (userInfo?.is_complete === "0") {
              history.push("/account-complete");
            }
            if (modal) {
              modal(false);
              window.location.reload();
            }
          }
        } else {
          dispatch({ type: THROW_ERROR, payload: res.body.message });
        }
      } else {
        dispatch({ type: THROW_ERROR, payload: err?.data?.message });
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
};

export const logoutAction = (history) => (dispatch) => {
  return superagent
    .post(`${base_url}logout`)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((err, res) => {
      if (res) {
        if (res.body.status) {
          dispatch({ type: THROW_SUCCESS, payload: res.body.message });
          cookie.remove("user_token", {
            path: "/",
            expires: new Date(Date.now() + 3600 * 1000 * 24),
          });
          cookie.remove("user_info", {
            path: "/",
            expires: new Date(Date.now() + 3600 * 1000 * 24),
          });
          dispatch({ type: GET_IS_PRO_MEMBER, payload: 0 });
          dispatch({ type: REMOVE_ACCOUNT_DATA });
          history.push("/");
        } else {
          dispatch({ type: THROW_ERROR, payload: res.body.message });
        }
      } else {
        dispatch({ type: THROW_ERROR, payload: err?.data?.message });
        dispatch({ type: IS_LOADING, payload: false });
      }
    });
};
